import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

// A variacao de um numero (spec do redesign, R5): o texto com o sinal e a cor do tom. Sem base diz "sem
// comparacao". O verde e so para o que melhorou e o ambar para o que pede atencao (R1).
const TONES = {
  good: { backgroundColor: "var(--color-delta-good-bg)", color: "var(--color-delta-good-text)" },
  bad: { backgroundColor: "var(--color-delta-bad-bg)", color: "var(--color-delta-bad-text)" },
  neutral: { backgroundColor: "var(--color-delta-neutral-bg)", color: "var(--color-delta-neutral-text)" },
};

const DeltaChip = ({ change }) => {
  const { translate } = useLanguage();
  if (change.text === null) {
    return (
      <span className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
        {translate("analyticsNoComparison")}
      </span>
    );
  }
  return (
    <span className="px-1.5 py-0.5 rounded text-xs font-semibold tabular-nums whitespace-nowrap" style={TONES[change.tone]}>
      {change.text}
    </span>
  );
};

export default DeltaChip;
